/**
 * Client-side submit validation (R10, U6 of
 * plans/2026-08-25-001-lead-scanner-implementation-plan.md) — the review
 * form's two required fields (Full Name*, Company*). Extracted as a pure,
 * zero-import module so it is independently unit-testable without rendering
 * `ScanReview.tsx`, and so the Submit button in the real component runs
 * this EXACT check rather than a hand-rolled duplicate the test asserts
 * against separately.
 *
 * The server-side floor (api.ts's `ScanSubmitSchema`, unmodified by this
 * unit) enforces the same two fields with `.min(1)` — this is the
 * client-side copy that lets the form show `invalid`/`errorMessage` on the
 * exact fields before ever making a request (plan: "Submit Button ...
 * validates name+company client-side first").
 */

export interface RequiredScanFields {
  name: string;
  company: string;
}

export interface RequiredFieldErrors {
  name: string | null;
  company: string | null;
}

export const NAME_REQUIRED_MESSAGE = 'Full name is required';
export const COMPANY_REQUIRED_MESSAGE = 'Company is required';

/** Whitespace-only counts as missing — matches the server's `.min(1)` on a
 *  trimmed value in spirit (a rep tabbing through and hitting space bars
 *  should not slip past the check). */
export function validateRequiredScanFields(fields: RequiredScanFields): RequiredFieldErrors {
  return {
    name: fields.name.trim() ? null : NAME_REQUIRED_MESSAGE,
    company: fields.company.trim() ? null : COMPANY_REQUIRED_MESSAGE,
  };
}

export function hasRequiredFieldErrors(errors: RequiredFieldErrors): boolean {
  return errors.name !== null || errors.company !== null;
}
